var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8563_49392",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666626 0.833496H17.7498V18.7543H0.666626V0.833496Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8563_49392)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4307 12.7428C11.434 12.7428 12.2507 13.5537 12.2507 14.5503V17.1137C12.2507 17.3278 12.4223 17.4995 12.6423 17.5045H14.2307C15.4823 17.5045 16.4998 16.4995 16.4998 15.2645V7.9945C16.494 7.5695 16.2915 7.1695 15.944 6.90367L10.4498 2.522C9.71234 1.93783 8.68067 1.93783 7.94067 2.52367L2.484 6.902C2.12317 7.17617 1.92067 7.57617 1.9165 8.00867V15.2645C1.9165 16.4995 2.934 17.5045 4.18567 17.5045H5.789C6.01484 17.5045 6.19817 17.3253 6.19817 17.1053C6.19817 17.057 6.204 17.0087 6.214 16.9628V14.5503C6.214 13.5595 7.02567 12.7495 8.0215 12.7428H10.4307ZM14.2307 18.7545H12.6273C11.709 18.7329 11.0007 18.012 11.0007 17.1137V14.5504C11.0007 14.2429 10.7448 13.9929 10.4307 13.9929H8.02567C7.71817 13.9945 7.464 14.2454 7.464 14.5504V17.1054C7.464 17.1679 7.45567 17.2279 7.43817 17.2845C7.34817 18.1095 6.64317 18.7545 5.789 18.7545H4.18567C2.24484 18.7545 0.666504 17.1887 0.666504 15.2645V8.00287C0.674837 7.17454 1.0565 6.4162 1.71567 5.91704L7.1615 1.5462C8.36067 0.596205 10.0315 0.596205 11.2282 1.54454L16.7132 5.91954C17.3573 6.41037 17.739 7.16704 17.7498 7.98537V15.2645C17.7498 17.1887 16.1715 18.7545 14.2307 18.7545Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99992 5.78809C8.65474 5.78809 8.37492 6.06791 8.37492 6.41309V8.07975H6.70825C6.36307 8.07975 6.08325 8.35958 6.08325 8.70475C6.08325 9.04993 6.36307 9.32975 6.70825 9.32975H8.37492V10.9964C8.37492 11.3416 8.65474 11.6214 8.99992 11.6214C9.3451 11.6214 9.62492 11.3416 9.62492 10.9964V9.32975H11.2916C11.6368 9.32975 11.9166 9.04993 11.9166 8.70475C11.9166 8.35958 11.6368 8.07975 11.2916 8.07975H9.62492V6.41309C9.62492 6.06791 9.3451 5.78809 8.99992 5.78809Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.54ff5b6651329378ae99b7b85a9aaaac.svg";
export { ForwardRef as ReactComponent };